
import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Navbar, OverlayTrigger, Popover, Tab, Tabs, Table, Badge } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { withTranslation } from "react-i18next";
import { BiPencil } from "react-icons/bi";
import { BsCameraFill, BsInfoCircle, BsTrash, BsCheckCircle, BsCheckLg, BsTranslate } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import PhoneNumber from "../../../components/PhoneNumber/PhoneNumber";
import { currentYear, LOADER_COLOR, LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY, LS_UI_ELEMENTS_CONFIG_KEY, LS_USER_ONBOARD_KEY, MonthsFull, startYear, USER_ROLE } from "../../../core/constants/common";
import { ONBOARD_TXT } from "../../../core/service/CommonService";
import CompanyService from "../../../core/service/CompanyService";
import ProfileSettingsService from "../../../core/service/ProfileSettingsService";
import UOMService from "../../../core/service/UOMService";
import UtilsService from "../../../core/service/UtilsService";
import Utils from "../../../core/utilities/Utils";
import EnterpriseGroup from "../../Common/EnterpriseGroup/EnterpriseGroup";
import EnterpriseStructure from "./EnterpriseStructure";
import "./ProfileSettings.scss";
import PermissionUtils from "../../../core/utilities/PermissisonUtils";
import CompanySelectBox from "../../../components/CompanySelectBox/CompanySelectBox";
import RegulationSelectBox from "../../../components/RegulationSelectBox/RegulationSelectBox";
import OrganizationCalendar from "./OrganizationCalendar";
import arrow from '../../../images/arrow.svg';
import Multiselect from "multiselect-react-dropdown";
import ImplementationGuide from "./ImplementationGuide";
import { CompanyInfoContext, PreferenceContext } from "../../../App";
import useHasPermission from "../../../core/hooks/useHasPermission";
import { clearPersistedPeriodFilters } from "../../../core/utilities/assessmentPeriodUtils";
import { hasGoalsKpiNavAccess } from "../GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../GoalsAndKpi/utils/hierarchyPermissions";

/** Calendar month immediately before the financial year start month. */
export function getFinancialYearEndForStart(startMonth) {
  const previousByStart = {
    JANUARY: 'DECEMBER',
    FEBRUARY: 'JANUARY',
    MARCH: 'FEBRUARY',
    APRIL: 'MARCH',
    MAY: 'APRIL',
    JUNE: 'MAY',
    JULY: 'JUNE',
    AUGUST: 'JULY',
    SEPTEMBER: 'AUGUST',
    OCTOBER: 'SEPTEMBER',
    NOVEMBER: 'OCTOBER',
    DECEMBER: 'NOVEMBER',
  };
  return previousByStart[startMonth] ?? 'MARCH';
}

function CompanySettings({ t }) {
 

  const [companyInfo, setCompanyInfo] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [contact, setContact] = useState("");
  const [phoneCodeCountry, setPhoneCodeCountry] = useState("");
  const [defaultContactCode, setDefaultContactCode] = useState("");
  const [defaultContactId, setDefaultContactId] = useState("");
  const [phoneCode, setPhoneCode] = useState([]);
  const [contactCode, setContactCode] = useState("");
  const [city, setCity] = useState("");
  const [selCountryOperational, setSelCountryOperational] = useState("");
  const [selCurrency, setSelCurrency] = useState("");
  const [selState, setSelState] = useState("");
  const [selCountry, setSelCountry] = useState("");
  const [validated, setValidated] = useState(false);
  const [legalName, setLegalName] = useState("");
  const [parentCompany, setParentCompany] = useState("");
  const [regNumber, setRegNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [contactName, setContactName] = useState("");
  const [designation, setDesignation] = useState("");
  const [email, setEmail] = useState("");
  const [defCountryOperational, setDefCountryOperational] = useState([]);
  const [defCurrency, setDefCurrency] = useState([]);
  const [defState, setDefState] = useState([]);
  const [defCountry, setDefCountry] = useState([]);
  const [street, setStreet] = useState("");
  const [building, setBuilding] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [imgFile, setImgFile] = useState("");
  const [companyDetails, setCompanyDetails] = useState(null);
  const [nodes, setNodes] = useState([]);
  const [businessUnitBased, setBusinessUnitBased] = useState(false);
  const [info, setInfo] = useState({
    industryId: '',
    about: '',
    esgFrameworks: '',
    esgGoals: '',
    matIssueCategory: '',
    materialityType: ''
  });
  const [industries, setIndustries] = useState([]);
  const location = useLocation();
 
  const [imgHere, setImgHere] = useState(false)
  const navigate = useNavigate();
 
 
  const [activeView, setActiveView] = useState('View');
  
  const [branchesData, setBranchesData] = useState([]);
  const [branchValidation, setBranchValidation] = useState(false)
  const [stateDataMap, setStateDataMap] = useState({});
  const [selectedCountry, setSelectedCountry] = useState(null);
 

  const [purpose, setPurpose] = useState([]);
  const [frameworks, setFrameworks] = useState([]);
  const [frequencyType, setFrequencyType] = useState('');
  const [baseYear, setBaseYear] = useState(2024);
  const [financialYearStart, setFinancialYearStart] = useState('APRIL');
  const [financialYearEnd, setFinancialYearEnd] = useState('MARCH');
  const [decimalPlaces, setDecimalPlaces] = useState(0);
  const [purposesList, setPurposesList] = useState([]);
  const [frameworksList, setFrameworksList] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const { setPreference } = useContext(PreferenceContext);
  const { setCompanyInfo: setGlobalCompanyInfo } = useContext(CompanyInfoContext);
  const [matIssueCategoryList, setMatIssueCategoryList] = useState([]);
  const { hasSettingsUpdatePermission, hasDoubleMaterialityUpdatePermission } = useHasPermission();
  const [uomContext, setUomContext] = useState("");
  const [uomVersion, setUomVersion] = useState("");
  const [uomVersions, setUomVersions] = useState([]);


  // Non-hook code moved after all hooks
 
  const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY) || 'null');
  const authorityData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || 'null');
  // TEMPORARY: same Goals & KPI nav check as the sidebar. Hide all Company tabs except Company Details. Revisit soon.
  const restrictNavToGoalsKpi = hasGoalsKpiNavAccess(
    buildHierarchyPermissions(Array.isArray(authorityData?.roles) ? authorityData.roles : [])
  );
  const [activeTab, setActiveTab] = useState(
    restrictNavToGoalsKpi
      ? 'Companydetails'
      : location?.state?.tab
        ?? (uiElementsConfig?.hiddenModules?.indexOf('SETTINGS_COMP_DETAILS') >= 0 ? 'epStruct' : 'Companydetails')
  );
  
  const objBranch = {
    name: '',
    branchId: '',
    address: {
      building: '',
      street: '',
      zipCode: '',
      // city:'',
      stateId: null,
      countryId: null,
    }
  }
  let messageConfirmation = t("ConfirmDeleteProfileImg.label");
  let color = LOADER_COLOR;
  const optionsMonth = MonthsFull({ t });
  const yearOptions = [];
  for (let i = currentYear; i >= startYear; i--) {
    yearOptions.push(<option value={i} key={i}>{i}</option>);
  }
  const lsUserOnboardData = JSON.parse(localStorage.getItem(LS_USER_ONBOARD_KEY) || 'null');
  const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || 'null');
  const companyId = authorityData?.profile?.company?.id;

  useEffect(() => {
    getESGUtils();
    getCompanyDetails(companyId);
    getEnterpriseStructure();
    getIndustries();
  }, []);

  useEffect(() => {
    // TEMPORARY: keep Company Details selected when Goals & KPI nav access is present. Revisit soon.
    if (restrictNavToGoalsKpi) {
      setActiveTab('Companydetails');
      return;
    }
    setActiveTab(location?.state?.tabKey || 'Companydetails');
  }, [location?.state?.tabKey]);

  const getCompanyDetails = async (companyId) => {
    ProfileSettingsService.getCompanyDetails(companyId)
      .then((response) => {
        getPhoneCodes();
        getCountry();
        getCurrency();
        getLanguages();
        getMatIssuesCategory();
        let data = response.data;
        setCompanyDetails(data);
        setImgFile(ProfileSettingsService.getProfileImg(companyId));
        setPhoneCodeCountry(data?.primaryContact?.contactNumber?.code?.name);
        setDefaultContactCode(
          data?.primaryContact?.contactNumber?.code?.phoneCode
        );
        setDefaultContactId(data?.primaryContact?.contactNumber?.code?.id);
        setContact(data?.primaryContact?.contactNumber?.number);
        setLegalName(data?.legalName);
        setDefCountryOperational(
          data?.operationalCountry ? [data.operationalCountry] : []
        );
        setSelCountryOperational(data?.operationalCountry?.id);
        setParentCompany(data?.parentCompany);
        setRegNumber(data?.regNumber);
        setTaxId(data?.taxId);
        setDefCurrency(data?.currency ? [data.currency] : []);
        setSelCurrency(data?.currency?.id);
        setDefCountry(data?.address?.country ? [data.address.country] : []);
        setSelCountry(data?.address?.country?.id);
        setDefState(data?.address?.state ? [data.address.state] : []);
        setSelState(data?.address?.state?.id);
        setCity(data?.address?.city);
        setStreet(data?.address?.street);
        setBuilding(data?.address?.building);
        setZipcode(data?.address?.zipCode);
        setContactName(data?.primaryContact?.name);
        setDesignation(data?.primaryContact?.designation);
        setEmail(data?.primaryContact?.email);
        setBusinessUnitBased(data?.businessUnitBased ?? false);
        if (data?.address?.country?.id) {
          getStatesForProfile(data?.address?.country?.id);
        }
        setInfo({
          industryId: data?.industry?.id ?? '',
          about: data.about,
          esgFrameworks: data.esgFrameworks,
          esgGoals: data.esgGoals,
          matIssueCategory: data.materialTopicCategory,
          materialityType: data.materialityType ?? ''
        });
        setPurpose(data?.purposes ?? [])
        setFrameworks(data?.frameworks ?? [])
        setFrequencyType(data?.dataFrequencyType ?? data?.frequencyType ?? '')
        setBaseYear(data?.baseYear ?? 2024)
        const fyStart = data?.financialYearStart ?? 'APRIL';
        setFinancialYearStart(fyStart);
        setFinancialYearEnd(getFinancialYearEndForStart(fyStart));
        setDecimalPlaces(data?.decimalPlaces ?? 0)
        const savedUomContext = (data?.uomContext === "COMPANY" || data?.uomContext === "SUPERSET") ? data?.uomContext : "";
        const savedUomVersion = data?.uomVersion ?? "";
        setUomContext(savedUomContext);
        setUomVersion(savedUomVersion ? String(savedUomVersion) : "");
        if (savedUomContext) {
          loadUomVersions(savedUomContext, savedUomVersion);
        } else {
          setUomVersions([]);
        }
        setSelectedLanguages(data?.languages);
      })
      .catch((error) => {
      });
  };
  const getCountry = () => {
    UtilsService.getCountryList()
      .then((response) => {
        setCountryData([...response.data]);
      })
      .catch((error) => {
      });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);

    if (selectedLanguages.length === 0) {
      toast.warning('Please fill all the mandatory fields');
      e.stopPropagation();
      return;
    }

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      toast.warning('Please fill all the mandatory fields');
    } else {
      companyInfo.id = companyId;
      companyInfo.legalName = legalName;
      companyInfo.regNumber = regNumber;
      companyInfo.taxId = taxId;
      companyInfo.logo = null;
      companyInfo.parentCompany = parentCompany;
      companyInfo['primaryContact'] = {};
      companyInfo['primaryContact']['name'] = contactName;
      companyInfo['primaryContact']['designation'] = designation;
      companyInfo['primaryContact']['contactNumber'] = {};
      companyInfo['primaryContact']['contactNumber']['code'] = {};
      companyInfo['primaryContact']['contactNumber']['code']['id'] = contactCode;
      companyInfo['primaryContact']['contactNumber']['number'] = contact;
      companyInfo['address'] = {};
      companyInfo['address']['building'] = building;
      companyInfo['address']['street'] = street;
      companyInfo['address']['zipCode'] = zipcode;
      companyInfo['address']['state'] = {};
      companyInfo['address']['state']['id'] = selState;
      companyInfo['address']['country'] = {};
      companyInfo['address']['country']['id'] = selCountry;
      companyInfo['address']['city'] = city;
      companyInfo['operationalCountry'] = {};
      companyInfo['operationalCountry']['id'] = selCountryOperational;
      if (companyInfo?.currency?.id) {
        companyInfo.currency.id = selCurrency;
      } else {
        if (selCurrency) {
          companyInfo["currency"] = {
            id: selCurrency,
          };
        }
      }
      companyInfo.businessUnitBased = businessUnitBased;
      if (info.industryId) {
        companyInfo.industry = {
          id: info.industryId ? +info.industryId : 0
        };
      }
      companyInfo.about = info.about;
      companyInfo.esgFrameworks = info.esgFrameworks;
      companyInfo.esgGoals = info.esgGoals;

      companyInfo.purposes = purpose;
      companyInfo.frameworks = frameworks;
      companyInfo.dataFrequencyType = frequencyType;
      companyInfo.baseYear = baseYear;
      companyInfo.financialYearStart = financialYearStart;
      companyInfo.financialYearEnd = financialYearEnd;
      companyInfo.decimalPlaces = decimalPlaces;
      companyInfo.uomContext = uomContext;
      companyInfo.uomVersion = uomVersion ? parseInt(uomVersion, 10) : null;
      companyInfo.languages = selectedLanguages.map(({ id, ...rest }) => rest);
      
      // Only include materiality fields if user has permission
      if (hasDoubleMaterialityUpdatePermission()) {
        companyInfo.materialTopicCategory = info.matIssueCategory;
        companyInfo.materialityType = info.materialityType;
      }

      const prevFreq = companyDetails?.dataFrequencyType ?? companyDetails?.frequencyType ?? '';
      const prevFyStart = companyDetails?.financialYearStart ?? 'APRIL';
      const prevFyEnd = companyDetails?.financialYearEnd ?? getFinancialYearEndForStart(prevFyStart);
      const periodSettingsChanged = Boolean(companyDetails) && (
        prevFreq !== frequencyType ||
        prevFyStart !== financialYearStart ||
        prevFyEnd !== financialYearEnd
      );

      ProfileSettingsService.updateCompanyDetails(companyInfo)
        .then((response) => {
          if (response.status === 200) {
            setActiveView('View');
            toast.success("Company details updated successfully", {
              position: toast.POSITION.TOP_RIGHT,
            });
            const lsCompanyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY) || 'null');
            if (lsCompanyInfo) {
              lsCompanyInfo['industry'] = info.industryId
                ? { id: +companyInfo.industry?.id, name: industries?.find(i => i.id === +info.industryId)?.name }
                : null;
              lsCompanyInfo['about'] = companyInfo.about;
              lsCompanyInfo['esgFrameworks'] = companyInfo.esgFrameworks;
              lsCompanyInfo['esgGoals'] = companyInfo.esgGoals;
              lsCompanyInfo['purposes'] = companyInfo.purposes;
              lsCompanyInfo['frameworks'] = companyInfo.frameworks;
              lsCompanyInfo['dataFrequencyType'] = companyInfo.dataFrequencyType;
              lsCompanyInfo['financialYearStart'] = companyInfo.financialYearStart;
              lsCompanyInfo['financialYearEnd'] = companyInfo.financialYearEnd;
              lsCompanyInfo['uomContext'] = companyInfo.uomContext;
              lsCompanyInfo['uomVersion'] = companyInfo.uomVersion;
              // Only update materiality fields if user has permission
              if (hasDoubleMaterialityUpdatePermission()) {
                lsCompanyInfo['materialTopicCategory'] = companyInfo.materialTopicCategory;
                lsCompanyInfo['materialityType'] = companyInfo.materialityType;
              }
              lsCompanyInfo['decimalPlaces'] = companyInfo.decimalPlaces;
              localStorage.setItem(LS_COMPANY_INFO_KEY, JSON.stringify(lsCompanyInfo));
              if (periodSettingsChanged) {
                clearPersistedPeriodFilters();
                if (typeof setGlobalCompanyInfo === 'function') {
                  setGlobalCompanyInfo(lsCompanyInfo);
                }
              }
            } else if (periodSettingsChanged) {
              clearPersistedPeriodFilters();
            }
            setPreference({ hasLanguagesChosen: true });
            getCompanyDetails(companyId);
          }
        })
        .catch((error) => {
        });
    }

  };
  const getPhoneCodeVal = (data) => {
    if (data.length > 0) {
      setContactCode(data[0].id);
    }
  };
  const getPhoneNumberVal = (data) => {
    setContact(data);
  };
  const getPhoneCodes = () => {
    UtilsService.getPhoneCodes()
      .then((response) => {
        setPhoneCode([...response.data]);
      })
      .catch((error) => { });
  };
  const getCurrency = () => {
    UtilsService.getCurrencyList()
      .then((response) => {
        setCurrencyData([...response.data]);
      })
      .catch((error) => { });
  };
  const getLanguages = () => {
    CompanyService.getLanguageList()
      .then((response) => {
        setLanguages([...response.data.data]);
      })
      .catch((error) => { });
  };
  const getStatesForProfile = async (countryId) => {
    if (countryId) {
      UtilsService.getStateList(countryId)
        .then((response) => {
          setStateData([...response.data]);
        })
        .catch((error) => { });
    }
  };
  const getMatIssuesCategory = () => {
    CompanyService.getMatIssuesCategory()
      .then(res => {
        if (res.status !== 200) return;

        setMatIssueCategoryList(res.data.data ?? []);
      })
      .catch(err => {
      });
  };
  useEffect(() => {
    branchesData.forEach((item, i) => {
      getStates(item.address.countryId, i);
    });
  }, [branchesData]);

  const getStates = async (countryId, index) => {
    if (countryId) {
      try {
        const response = await UtilsService.getStateList(countryId);
        setStateDataMap((prevState) => ({
          ...prevState,
          [index]: response.data,
        }));
      } catch (error) { }
    }
  };

  const handleFileSelect = (e) => {
    e.preventDefault();
    setLoading(true);
    const fileUploaded = e.target.files[0];

    const formData = new FormData();
    formData.append("file", fileUploaded);
    ProfileSettingsService.updateCompanyLogo(companyId, formData)
      .then((response) => {
        fetchImg();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setImgHere(true);
      });
  };

  const handleDeleteProfileImg = () => {

    if (imgHere) {

      setShowDeleteConfirm(true);
      setImgHere(false)
    }

  };
  const callbackDeleteImg = (boolVal) => {
    setShowDeleteConfirm(false);
    boolVal && handleDeleteImg();
  };
  const handleDeleteImg = () => {
    setLoading(true);
    const formData = new FormData();
    ProfileSettingsService.deleteCompanyLogo(companyId, formData)
      .then((response) => {
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          fetchImg();
        }
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error) => { });
  };
  const fetchImg = () => {
    let img = ProfileSettingsService.getProfileImg(companyId);
    // update header logo image
    var eleImgs = document.getElementsByClassName("profileImg");
    for (let i = 0; i < eleImgs.length; i++) {
      eleImgs[i].src = img;
    }
    setImgFile(img);
  };
  //branch
  //validation
  const validateInputs = () => {
    branchesData.forEach((item, index) => {
      if (item.name === "" || item.address.building === "" || item.address.street === "" || item.address.zipCode) {
        setBranchValidation(true)
      }
    });

    return branchValidation;
  }
  //end
  const addBranch = () => {
    let arr = [...branchesData];
    arr.push(objBranch);
    setBranchesData(arr);
  };

  const handleFormChange = (index, event, key) => {
    let data = [...branchesData];
    if (key !== null) {
      data[index][key][event.target.name] = event.target.value;
    } else {
      data[index][event.target.name] = event.target.value;
    }
    setBranchesData(data);
  };

  const handleDropdownChange = (index, key, id) => {
    let data = [...branchesData];
    data[index]['address'][key] = id;
    if (key !== 'stateId') {
      getStates(id);
    }
    setBranchesData(data);
  };

  const saveBranch = () => {
    // cancelBranch();
    let errorBranch = false;
    let data = [...branchesData]
    data.forEach((item, index) => {
      if (item.name === "" || item.address.building === "" || item.address.street === "" || item.address.zipCode === "" || item.address.countryId === null || item.address.stateId === null) {
        errorBranch = true;
      }
    });
    if (errorBranch) {
      setBranchValidation(true)
    } else {
      ProfileSettingsService.addBranches(companyId, branchesData)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.length == 1) {
              if (response.data[0].body) {
                setActiveView('View')
                toast.success("Updated Successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              } else {
                toast.error(response.data[0].message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              }
            } else {

              if (response.data[0].body) {
                toast.success("Successfully added new branch", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              } else {
                toast.error(response.data[0].message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              }
              if (response.data[1].body) {
                toast.success("Updated Successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              } else {
                toast.error(response.data[1].message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000
                });
              }
            }
          }
          cancelBranch();
        })
        .catch((error) => { });
    }
  }
  const cancelBranch = () => {
    handleSelect("branches")
  }
  const getBranches = () => {
    ProfileSettingsService.getBranches(companyId)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.body && response.data.body.length > 0) {
            setBranchesData([...response.data.body]);
          } else {
            setBranchesData([objBranch])
          }
        } else {
          setBranchesData([objBranch])
        }
      })
      .catch((error) => { });
  }
  const handleSelect = (key) => {
    navigate('../company_settings')
    if (key === 'branches') {
      getBranches();
    }
    // TEMPORARY: ignore tab changes other than Company Details when Goals & KPI nav access is present. Revisit soon.
    if (restrictNavToGoalsKpi) {
      setActiveTab('Companydetails')
      return
    }
    setActiveTab(key)
  }

  const getEnterpriseStructure = () => {
    CompanyService.getEnterpriseStructure()
      .then(res => {
        if (res.status !== 200) return;

        setNodes(res.data.data);
      })
      .catch(err => {
      });
  };

  const getIndustries = () => {
    CompanyService.getIndustries()
      .then(res => {
        if (res.status !== 200) return;

        setIndustries(res.data ?? []);
      })
      .catch(err => {
      });
  };

  const CustomArrow = ({ isOpen }) => {
    return (
      // isOpen ? arrow : arrow
      <img src={arrow} alt="Arrow" />
    );
  };

  const getSelectedPurpose = () => {
    const data = [];
    purposesList?.forEach(pur => {
      if (purpose.indexOf(pur.code) < 0) return;
      data.push(pur);
    });
    return data;
  }

  const getSelectedFramework = () => {
    const data = [];
    frameworksList?.forEach(frame => {
      if (frameworks.indexOf(frame.code) < 0) return;
      data.push(frame);
    });
    return data;
  }

  const onSelectDeSelectPurpose = (selectedItem) => {
    const purposeIds = [...purpose];
    const index = purpose.indexOf(selectedItem.code);
    if (index >= 0) {
      purposeIds.splice(index, 1);
    } else {
      purposeIds.push(selectedItem.code);
    }
    setPurpose(purposeIds);
  };

  const onSelectDeSelectFramework = (selectedItem) => {
    const frameworkIds = [...frameworks];
    const index = frameworks.indexOf(selectedItem.code);
    if (index >= 0) {
      frameworkIds.splice(index, 1);
    } else {
      frameworkIds.push(selectedItem.code);
    }
    setFrameworks(frameworkIds);
  };

  const getESGUtils = () => {
    ProfileSettingsService.getEsgUtils()
      .then(res => {
        if (res.status !== 200) return;

        setPurposesList(res.data.purposes);
        setFrameworksList(res.data.frameworks);
      })
      .catch(err => {
      });
  };

  const getNames = (type, code) => {
    if (type == 'purpose') {
      let result = purposesList.find(x => x.code === code)
      return result ? result['name'] : 'NA';
    } else {
      let result = frameworksList.find(x => x.code === code)
      return result ? result['name'] : 'NA';
    }
  }

  const onSelectDeSelectLanguage = (selectedItem) => {
    setSelectedLanguages((prevSelected) => {
      const isSelected = prevSelected.some(item => item.id === selectedItem.id);

      if (isSelected) {
        return prevSelected.filter(item => item.id !== selectedItem.id);
      } else {
        return [...prevSelected, { ...selectedItem, primary: false }];
      }
    });
  };

  const handleDefaultLanguageChange = (e) => {
    setSelectedLanguages((prevSelected) => {
      return prevSelected.map(language => ({
        ...language,
        primary: language.id === +e.target.value
      }));
    });
  };

  const renderInfoElements = () => {
    return (
      <>
        {activeView === 'View' ? (
          <>
            <div className="col-lg-12 p-2">
              <label className="mb-2 text-muted" htmlFor="industrySelector">{t("Industry.label")}</label>
              <h6 className="mb-0">
                {info.industryId
                  ? industries.find((industry) => industry.id === info.industryId)?.name
                  : 'Not Selected'}
              </h6>
            </div>

            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("PurposeOfUsingApp.label")}
              </label>
              <ul className="list_boxview">
                {
                  purpose?.length > 0 &&
                  purpose.map((purp, index) => {
                    return (
                      <li><BsCheckCircle className="text-success" /> {getNames('purpose', purp)}</li>
                    )
                  })
                }
                {
                  purpose?.length == 0 && 'Not available'
                }
              </ul>
            </div>

            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("Framework.label")}
                <OverlayTrigger

                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">
                        {t('FrameworkToolTip.label')}
                      </div>
                    </Popover>
                  }>
                  <span className="ms-1"><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <ul className="list_boxview">
                {
                  frameworks?.length > 0 &&
                  frameworks.map((frame, index) => {
                    return (
                      <li><BsCheckCircle className="text-success" /> {getNames('framework', frame)}</li>
                    )
                  })
                }
                {
                  frameworks?.length == 0 && 'Not available'
                }
              </ul>
            </div>

            {hasDoubleMaterialityUpdatePermission() && (
              <>
                <div className="col-lg-6 p-2">
                  <label className="mb-2 text-muted" htmlFor="materialityTypeSelector">{t("MaterialityType.label")}</label>
                  <h6 className="mb-0">
                    {info.materialityType ? (info.materialityType === 'SINGLE' ? 'Impact Materiality' : info.materialityType === 'DOUBLE' ? 'Double Materiality' : info.materialityType) : 'Not Selected'}
                  </h6>
                </div>

                <div className="col-lg-6 p-2">
                  <label className="mb-2 text-muted" htmlFor="industrySelector">{t("MaterialIssueCategory.label")}</label>
                  <h6 className="mb-0">
                    {info.matIssueCategory ? info.matIssueCategory : 'Not Selected'}
                  </h6>
                </div>
              </>
            )}

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("BaseYear.label")}
              </label>
              <h6 className="mb-0">{baseYear ?? 'NA'}</h6>
            </div>
            <div className="w-100" />

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FrequencyType.label")}
              </label>
              <h6 className="mb-0">{frequencyType === 'CY' ? t("FrequencyType.calendarYear.label") : frequencyType === 'FY' ? t("FrequencyType.financialYear.label") : (frequencyType ? frequencyType : 'NA')}</h6>
            </div>

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FinancialYearStart.label")}
              </label>
              <h6 className="mb-0">{financialYearStart !== null ? Utils.toTitleCase(financialYearStart) : 'NA'}</h6>
            </div>

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FinancialYearEnd.label")}
              </label>
              <h6 className="mb-0">{financialYearEnd !== null ? Utils.toTitleCase(financialYearEnd) : 'NA'}</h6>
            </div>

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("DecimalPlaces.label")}
              </label>
              <h6 className="mb-0">{decimalPlaces ?? 'NA'}</h6>
            </div>

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("CompanySettings.uomContext.label")}
              </label>
              <h6 className="mb-0">
                {uomContext === "COMPANY" ? t("Company.label") : uomContext === "SUPERSET" ? t("Admin.label") : 'NA'}
              </h6>
            </div>

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("CompanySettings.uomVersion.label")}
              </label>
              <h6 className="mb-0">{getSelectedUomVersionDisplay()}</h6>
            </div>

            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("About.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("CompanyAboutHelper.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <h6 className="mb-0">{info.about}</h6>
            </div>
            <div className="col-lg-12 p-2 d-none">
              <label className="mb-1 text-muted">{t("ESGFrameworks.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("ESGFrameworkHelpText.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <h6 className="mb-0">{info.esgFrameworks}</h6>
            </div>
            <div className="col-lg-12 p-2 d-none">
              <label className="mb-1 text-muted">{t("ESGGoals.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("ESGGoalsHelpText.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <h6 className="mb-0">{info.esgGoals}</h6>
            </div>
          </>
        ) : (
          <>
            <div className="col-lg-12 p-2">
              <label htmlFor="industrySelector" className="text-muted">{t("Industry.label")} <span className="text-danger">*</span></label>
              <select
                id="industrySelector"
                className="form-select"
                onChange={(e) => setInfo({ ...info, industryId: e.target.value })}
                value={info.industryId}
                required
                disabled={activeView === 'View'}
              >
                <option value='' key='' disabled>{t('Select.label')}</option>
                {
                  industries
                    ?.slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((e) => (
                      <option value={e.id} key={e.id}>{e.name}</option>
                    ))
                }
              </select>
            </div>
            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("PurposeOfUsingApp.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <Multiselect
                id="purposeMultiSelect"
                key="purposeMultiSelect"
                options={purposesList}
                selectedValues={getSelectedPurpose()}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectPurpose(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectPurpose(selectedItem);
                }}
                placeholder={getSelectedPurpose().length === 0 ? "Select " : ""}
                displayValue="name"
                customArrow={<CustomArrow />}
                showArrow={true}
                required
              />
            </div>
            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("Framework.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <Multiselect
                id="frameworkMultiSelect"
                key="frameworkMultiSelect"
                options={getSelectedPurpose().length > 0 ? getCompatibleFrameWorks() : frameworksList}
                selectedValues={getSelectedFramework()}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectFramework(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectFramework(selectedItem);
                }}
                placeholder={getSelectedFramework().length === 0 ? "Select " : ""}
                displayValue="name"
                customArrow={<CustomArrow />}
                showArrow={true}
                required
              />
            </div>

            {hasDoubleMaterialityUpdatePermission() && (
              <>
                <div className="col-lg-6 p-2">
                  <label className="text-muted">{t("MaterialityType.label")} <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    onChange={(e) => setInfo({ ...info, materialityType: e.target.value })}
                    value={info.materialityType}
                    required
                    disabled={activeView === 'View'}
                  >
                    <option value='' key='' disabled>{t('Select.label')}</option>
                    <option value="SINGLE" key="single">Impact Materiality</option>
                    <option value="DOUBLE" key="double">Double Materiality</option>
                  </select>
                </div>

                <div className="col-lg-6 p-2">
                  <label htmlFor="industrySelector" className="text-muted">{t("MaterialIssueCategory.label")} <span className="text-danger">*</span></label>
                  <select id="industrySelector"
                    className="form-select"
                    onChange={(e) => setInfo({ ...info, matIssueCategory: e.target.value })}
                    value={info.matIssueCategory}
                    required
                    disabled={activeView === 'View'}
                  >
                    <option value='' key='' disabled>{t('Select.label')}</option>
                    {
                      matIssueCategoryList?.map((e, index) => {
                        return <option value={e.name} key={e.id}>{e.name}</option>;
                      })
                    }
                  </select>
                </div>
              </>
            )}

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("BaseYear.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <select className="form-select" value={baseYear} onChange={(e) => { setBaseYear(e.target.value) }} required>
                {yearOptions}
              </select>
            </div>
            <div className="w-100" />

            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FrequencyType.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-select"
                value={frequencyType}
                onChange={(e) => setFrequencyType(e.target.value)}
                required
              >
                <option value="" disabled>{t("Select.label")}</option>
                <option value="CY">{t("FrequencyType.calendarYear.label")}</option>
                <option value="FY">{t("FrequencyType.financialYear.label")}</option>
              </select>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FinancialYearStart.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-select"
                required
                value={financialYearStart}
                onChange={(e) => {
                  const v = e.target.value;
                  setFinancialYearStart(v);
                  setFinancialYearEnd(getFinancialYearEndForStart(v));
                }}>
                {
                  optionsMonth?.map((items) => (
                    <option value={items.value} key={items.value}>
                      {items.label}
                    </option>
                  ))
                }
              </select>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("FinancialYearEnd.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-select"
                required
                value={financialYearEnd}
                disabled
                data-testid="company-settings-financial-year-end"
              >
                {
                  optionsMonth?.map((items) => (
                    <option value={items.value} key={items.value}>
                      {items.label}
                    </option>
                  ))
                }
              </select>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("DecimalPlaces.label")}
              </label>
              <input
                type="number"
                className="form-control"
                min="0"
                max="10"
                value={decimalPlaces}
                onChange={(e) => setDecimalPlaces(parseInt(e.target.value) || 0)}
                disabled={activeView === 'View'}
              />
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("CompanySettings.uomContext.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  id="uom-context-superset"
                  name="uomContext"
                  label={t("Admin.label")}
                  value="SUPERSET"
                  checked={uomContext === "SUPERSET"}
                  onChange={(e) => handleUomContextChange(e.target.value)}
                />
                <Form.Check
                  inline
                  type="radio"
                  id="uom-context-company"
                  name="uomContext"
                  label={t("Company.label")}
                  value="COMPANY"
                  checked={uomContext === "COMPANY"}
                  onChange={(e) => handleUomContextChange(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-4 p-2">
              <label className="mb-1 text-muted">
                {t("CompanySettings.uomVersion.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-select"
                value={uomVersion}
                onChange={(e) => setUomVersion(e.target.value)}
                required
              >
                <option value="" disabled>{t("Select.label")}</option>
                {uomVersions.map((version) => (
                  <option key={version.id} value={version.id}>
                    {version.versionName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-12 p-2">
              <label className="mb-1 text-muted">
                {t("About.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("CompanyAboutHelper.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <textarea
                className="form-control"
                rows={8}
                maxLength={1800}
                value={info.about}
                onChange={(e) => setInfo({ ...info, about: e.target.value })}

              >
              </textarea>
            </div>
            <div className="col-lg-12 p-2 d-none">
              <label className="mb-1 text-muted">{t("ESGFrameworks.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("ESGFrameworkHelpText.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <textarea
                className="form-control"
                value={info.esgFrameworks}
                onChange={(e) => setInfo({ ...info, esgFrameworks: e.target.value })}

              >
              </textarea>
            </div>
            <div className="col-lg-12 p-2 d-none">
              <label className="mb-1 text-muted">{t("ESGGoals.label")}&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover id="popover-trigger-hover-focus" className="p-2">
                      <div className="p-1">{t("ESGGoalsHelpText.label")}</div>
                    </Popover>
                  }>
                  <span><BsInfoCircle /></span>
                </OverlayTrigger>
              </label>
              <textarea
                rows={8}
                className="form-control"
                value={info.esgGoals}
                onChange={(e) => setInfo({ ...info, esgGoals: e.target.value })}
              >
              </textarea>
            </div>
          </>
        )
        }
      </>
    );
  };

  const renderReadonlyView = () => {
    return (
      <div className="row mx-0 mb-2 ProfileViewData">
        <div className="col-lg-12 px-2">
          <b className="subhead_profile">
            {t("BasicDetails.label")}
          </b>
        </div>

        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("orgLegalName.label")}</label>
          <h6 className="mb-0">{legalName}</h6>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("countryOfOperation.label")}</label>
          {countryData.length > 0 && (
            <h6 className="mb-0">
              {selCountryOperational
                ? countryData.find((country) => country.id === selCountryOperational)?.name
                : t("Select.label")}
            </h6>

          )}
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("parentCompany.label")}</label>
          <h6 className="mb-0">{parentCompany}</h6>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("CompanyRegisrationNumber.label")}</label>
          <h6 className="mb-0">{regNumber}</h6>
        </div>

        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("taxId.label")}</label>
          <h6 className="mb-0">{taxId}</h6>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("currency.label")}</label>
          <h6 className="mb-0">
            {selCurrency
              ? currencyData.find((currency) => currency.id === selCurrency)?.name
              : t("Select.label")}
          </h6>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("Languages.label")}</label>
          <ul className="list_boxview">
            {
              selectedLanguages?.map((language, index) => {
                return (
                  <li key={index}><BsTranslate className="text-success" /> {language.name}</li>
                )
              })
            }
          </ul>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("DefaultLanguage.label")}</label>
          <ul className="list_boxview">
            {
              selectedLanguages?.map((language, index) => {
                return (
                  language.primary && (
                    <li key={index}>
                      <BsTranslate className="text-success" /> {language.name}
                    </li>
                  )
                );
              })
            }
          </ul>
        </div>
        <div className="col-lg-12 p-2">
          <label className="mb-1 text-muted">{t("Configuration.label")}</label>
          {
            lsUserOnboardData && lsUserOnboardData.nextStep == ONBOARD_TXT
              ? <></>
              : <><Navbar id="responsive-navbar-nav 1" className="me-auto p-0">
                {PermissionUtils.isSupplierAdmin(lsData.roles) && <CompanySelectBox />}
                &nbsp;
                <RegulationSelectBox />
              </Navbar></>
          }
        </div>
      </div>
    )
  };

  const getCompatibleFrameWorks = () => {
    const selectedPurposes = getSelectedPurpose();
    const compatibleFrameworks = [];
    selectedPurposes?.forEach(p => {
      p.compatibleFrameworks?.forEach(f => {
        if (compatibleFrameworks?.findIndex(fw => fw.code === f) >= 0) return;

        compatibleFrameworks.push({
          code: f,
          name: f
        });
      });
    });
    return compatibleFrameworks;
  };

  const loadUomVersions = (context, preferredVersion = null) => {
    const uomCompanyId = context === "COMPANY" ? companyId : null;
    UOMService.listVersions(uomCompanyId)
      .then((response) => {
        const versions = response?.data || [];
        setUomVersions(versions);

        if (preferredVersion !== null && preferredVersion !== undefined && preferredVersion !== "") {
          const matchedVersion = versions.find((item) =>
            String(item?.versionNumber) === String(preferredVersion) || String(item?.id) === String(preferredVersion)
          );
          setUomVersion(
            matchedVersion
              ? String(matchedVersion.id ?? matchedVersion.versionNumber)
              : (versions[0] ? String(versions[0].id ?? versions[0].versionNumber) : "")
          );
          return;
        }

        setUomVersion((prev) => {
          const exists = versions.some((item) => String(item?.id ?? item?.versionNumber) === String(prev));
          if (exists) return prev;
          return versions[0] ? String(versions[0].id ?? versions[0].versionNumber) : "";
        });
      })
      .catch(() => {
        setUomVersions([]);
        setUomVersion("");
      });
  };

  const handleUomContextChange = (nextContext) => {
    setUomContext(nextContext);
    setUomVersion("");
    loadUomVersions(nextContext);
  };

  const getSelectedUomVersionDisplay = () => {
    const selected = uomVersions.find((item) => String(item?.id ?? item?.versionNumber) === String(uomVersion));
    if (!selected) return uomVersion || "NA";
    return selected.versionName
      ? `${selected.versionName} (${selected.versionNumber})`
      : `${t("Version.label")} ${selected.versionNumber}`;
  };

  return (
    <div className="ProfileSettings">
      <div className="List_header pb-0">
        <h5 className="MH m-0">{t("CompanyProfile.label")}</h5>

        {activeTab === 'Companydetails' && activeView === 'View' && (
          <Button
            variant="primary"
            hidden={!hasSettingsUpdatePermission()}
            onClick={() => {
              setActiveView('Edit');
            }}
          >
            <BiPencil /> {t("Edit.label")}
          </Button>
        )}

      </div>

      <div className="row m-0 justify-content-center">
        <div className="col-lg-12 p-0">
          <Tabs
            activeKey={activeTab}
            id="uncontrolled-tab-example"
            className="Companysettings-tab"
            onSelect={(k) => handleSelect(k)}>
            {
              (!uiElementsConfig || uiElementsConfig?.hiddenModules?.indexOf('SETTINGS_COMP_DETAILS') < 0) &&
              <Tab eventKey="Companydetails" title={t("CompanyDetails.label")}>
                <div className="card company-details-card mt-2">


                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="card-body p-0">

                      <div className="row m-0">
                        <div className="col-lg-4 p-2 basic_details_CD">
                          <div className="company-logo">
                            <div className="company-logo-add">
                              <img src={imgFile} alt={companyInfo.legalName} />
                              <div className="img-edit">
                                <div>
                                  {loading && (
                                    <div className="loader-custom">
                                      <ScaleLoader color={color} loading={true} size={25} />
                                    </div>
                                  )}
                                  <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => handleFileSelect(e)}
                                    onClick={(e) => {
                                      e.target.value = null;
                                    }}

                                  />
                                  <label htmlFor="imageUpload">
                                    <BsCameraFill />
                                  </label>
                                </div>
                                <div className="mt-2">
                                  <span htmlFor="imageUpload">
                                    <BsTrash onClick={handleDeleteProfileImg} />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="company-names p-2">
                              <h5 className="m-0">{companyInfo.legalName}</h5>{" "}
                            </div>
                          </div>

                          {activeView === 'View' ? renderReadonlyView() : (
                            <div className="row mx-0 mb-2">

                              <div className="col-lg-12 px-2">
                                <b className="subhead_profile">
                                  {t("BasicDetails.label")}
                                </b>
                              </div>

                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">{t("orgLegalName.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="legalName"
                                  onChange={(e) => setLegalName(e.target.value)}
                                  value={legalName}
                                  required
                                />
                              </div>
                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">{t("countryOfOperation.label")} <span className="text-danger">*</span></label>
                                {countryData.length > 0 && (
                                  <Typeahead
                                    clearButton
                                    defaultSelected={defCountryOperational}
                                    id="country_op"
                                    labelKey={(options) => options.name}
                                    onChange={(selected) => {
                                      if (selected[0]) {
                                        setSelCountryOperational(selected[0].id);
                                      }
                                    }}
                                    options={countryData}
                                    placeholder={t("Select.label")}
                                    inputProps={{ required: true }}
                                  />
                                )}
                              </div>
                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">{t("parentCompany.label")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={parentCompany}
                                  onChange={(e) => setParentCompany(e.target.value)}

                                />
                              </div>
                              <div className="col-lg-12 p-2">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={Utils.renderTooltip(
                                    t("CompanyRegisrationText.label")
                                  )}
                                >
                                  <label className="mb-1 text-muted">{t("CompanyRegisrationNumber.label")}</label>
                                </OverlayTrigger>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={regNumber}
                                  onChange={(e) => setRegNumber(e.target.value)}

                                />
                              </div>

                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">{t("taxId.label")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={taxId}
                                  onChange={(e) => setTaxId(e.target.value)}

                                />
                              </div>
                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">{t("currency.label")}</label>
                                {currencyData.length > 0 && (
                                  <Typeahead
                                    clearButton
                                    defaultSelected={defCurrency}
                                    id="currency"
                                    onChange={(selected) => {
                                      if (selected[0]) {
                                        setSelCurrency(selected[0].id);
                                      }
                                    }}
                                    labelKey={(options) => options.name}
                                    options={currencyData}
                                    placeholder={t("Select.label")}
                                    inputProps={{ required: true }}

                                  />
                                )}
                              </div>
                              <div className="col-lg-12 p-2">
                                <label className="mb-1 text-muted">
                                  {t("Languages.label")}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <Multiselect
                                  id="languageMultiSelect"
                                  key="languageMultiSelect"
                                  options={languages}
                                  selectedValues={selectedLanguages}
                                  onSelect={(selectedList, selectedItem) => {
                                    onSelectDeSelectLanguage(selectedItem);
                                  }}
                                  onRemove={(selectedList, selectedItem) => {
                                    onSelectDeSelectLanguage(selectedItem);
                                  }}
                                  placeholder={selectedLanguages.length === 0 ? "Select " : ""}
                                  displayValue="name"
                                  customArrow={<CustomArrow />}
                                  showArrow={true}
                                  required
                                />
                              </div>
                              <div className="col-lg-12 p-2">
                                <label htmlFor="defaultLanguageSelector" className="mb-1 text-muted">{t("DefaultLanguage.label")} <span className="text-danger">*</span></label>
                                <select id="defaultLanguageSelector"
                                  className="form-select"
                                  onChange={handleDefaultLanguageChange}
                                  value={selectedLanguages.find(language => language.primary)?.id || ''}
                                  required
                                  disabled={activeView === 'View' || selectedLanguages.length === 0}
                                >
                                  <option value='' key='' disabled>{t('Select.label')}</option>
                                  {
                                    selectedLanguages?.map((lang, index) => {
                                      return <option value={lang.id} key={lang.id}>{lang.name}</option>;
                                    })
                                  }
                                </select>
                              </div>
                              {/* {renderInfoElements()} */}
                            </div>
                          )}


                        </div>
                        <div className="col-lg-8 p-2">

                          {activeView === 'View' ? (

                            <div className="row mx-0 mb-2 ProfileViewData">

                              <div className="col-lg-12 px-2">
                                <b className="subhead_profile">
                                  {t("compAddress.label")}
                                </b>
                              </div>

                              <div className="col-lg-6 p-2">
                                <h6 className="mb-0">
                                  {building &&
                                    <span className="me-1">{building},</span>
                                  }
                                  {street &&
                                    <span className="me-1">{street},</span>
                                  }
                                  {city &&
                                    <span className="me-1">{city},</span>
                                  }
                                  <span className="me-1">
                                    {selState
                                      ? stateData.find((state) => state.id === selState)?.name
                                      : t("Select.label")},
                                  </span>
                                  <span className="me-1">

                                    {selCountry
                                      ? countryData.find((country) => country.id === selCountry)?.name +
                                      " (" + countryData.find((country) => country.id === selCountry)?.code + ")"
                                      : t("Select.label")}
                                  </span>

                                  {zipcode &&
                                    <span> -
                                      {zipcode}
                                    </span>
                                  }

                                </h6>
                              </div>
                            </div>
                          ) : (
                            <div className="row mx-0 mb-2">

                              <div className="col-lg-12 px-2">
                                <b className="subhead_profile">
                                  {t("compAddress.label")}
                                </b>
                              </div>

                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("country.label")} <span className="text-danger">*</span></label>
                                {countryData.length > 0 && (
                                  <Typeahead
                                    clearButton
                                    defaultSelected={defCountry}
                                    id="country"
                                    onChange={(selected) => {
                                      if (selected[0]) {
                                        setSelCountry(selected[0].id);
                                        getStatesForProfile(selected[0].id);
                                      }
                                    }}
                                    labelKey={(options) =>
                                      options.name + "(" + options.code + ")"
                                    }
                                    options={countryData}
                                    inputProps={{ required: true }}
                                    placeholder={t("Select.label")}

                                  />
                                )}
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("state.label")} <span className="text-danger">*</span></label>
                                {countryData.length > 0 && (
                                  <Typeahead
                                    clearButton
                                    id="state"
                                    defaultSelected={defState}
                                    onChange={(selected) => {
                                      if (selected[0]) {
                                        setSelState(selected[0].id);
                                      }
                                    }}
                                    labelKey={(options) => options.name}
                                    options={stateData}
                                    inputProps={{ required: true }}
                                    placeholder={t("Select.label")}

                                  />
                                )}
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("street.label")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={street}
                                  onChange={(e) => setStreet(e.target.value)}

                                />
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("city.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("building.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={building}
                                  onChange={(e) => setBuilding(e.target.value)}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("zipcode.label")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={zipcode}
                                  onChange={(e) => setZipcode(e.target.value)}

                                />
                              </div>
                            </div>
                          )}

                          {activeView === 'View' ? (
                            <div className="row mx-0 mb-2 ProfileViewData">

                              <div className="col-lg-12 px-2">
                                <b className="subhead_profile">
                                  {t("contactPerson.label")}
                                </b>
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("primaryContactName.label")}</label>
                                <h6 className="mb-0">{contactName} </h6>
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("primaryContactRole.label")}</label>
                                <h6 className="mb-0">{designation}</h6>
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("contactEmail.label")}</label>
                                <h6 className="mb-0">
                                  {email}
                                </h6>
                              </div>

                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">
                                  {t("ContactNumber.label")}
                                </label>

                                <h6>
                                  <span className="me-2">+ {defaultContactCode}</span>
                                  <span>{contact}</span>
                                </h6>
                              </div>
                            </div>
                          ) : (
                            <div className="row mx-0 mb-2">

                              <div className="col-lg-12 px-2">
                                <b className="subhead_profile">
                                  {t("contactPerson.label")}
                                </b>
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("primaryContactName.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={contactName}
                                  onChange={(e) => setContactName(e.target.value)}
                                  id="contactName"
                                  required
                                />
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("primaryContactRole.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={designation}
                                  onChange={(e) => setDesignation(e.target.value)}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">{t("contactEmail.label")} <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  disabled
                                />
                              </div>

                              <div className="col-lg-6 p-2">
                                <label className="mb-1 text-muted">
                                  {t("ContactNumber.label")} <span className="text-danger">*</span>
                                </label>
                                <div className="row px-1">
                                  {defaultContactCode && (
                                    <PhoneNumber
                                      onCodeSelected={getPhoneCodeVal}
                                      phoneNumber={getPhoneNumberVal}
                                      codelabel={t("phoneCode.label")}
                                      contact={contact}
                                      defaultContactCode={defaultContactCode}
                                      phoneCodeCountry={phoneCodeCountry}
                                      defaultContactId={defaultContactId}
                                      disabled_View={activeView === 'View'}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}



                          <div className="row m-0 ProfileViewData">
                            <div className="col-lg-12 px-2">
                              <b className="subhead_profile">
                                {t("MoreDetails.label")}
                              </b>
                            </div>

                            {renderInfoElements()}

                          </div>

                        </div>

                        {activeView !== 'View' &&

                          <div className="col-lg-12 p-2  text-center">
                            <button
                              type="button"
                              className="btn btn-secondary me-2 px-4"
                              onClick={() => {
                                setActiveView('View');
                                getCompanyDetails(companyId);
                              }}
                            >
                              {t("Cancel.label")}
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary px-4"
                            // onClick={() => {
                            //   setActiveView('View');
                            // }}
                            >
                              {t("Save.label")}
                            </button>
                          </div>
                        }

                      </div>

                    </div>
                  </Form>
                </div>
              </Tab>
            }
            {/* TEMPORARY: hide these tabs when Goals & KPI nav access is present. Revisit soon. */}
            {!restrictNavToGoalsKpi && (
              <Tab eventKey="epStruct" title={t("EnterpriseStructure.label")}>
                {activeTab === 'epStruct' && (
                  <div className="card border-0">
                    <EnterpriseStructure epNodes={nodes}
                      company={companyDetails}
                      onEPStructureRefresh={(data) => setNodes(data)} />
                  </div>
                )}
              </Tab>
            )}
            {!restrictNavToGoalsKpi && (
              <Tab eventKey="epGroup" title={t("EnterpriseGroup.label")}>
                {activeTab === 'epGroup' && (
                  <div className=" border-0">
                    <EnterpriseGroup epNodes={nodes} />
                  </div>
                )}
              </Tab>
            )}
            {!restrictNavToGoalsKpi && (
              <Tab eventKey="orgCalendar" className="calendar_tab" title={<><span>{t("Calendar.label")}</span> <span className='calender_Beta'>Beta</span></>}>
                {activeTab === 'orgCalendar' && (
                  <div className="card border-0">
                    <OrganizationCalendar />
                  </div>
                )}
              </Tab>
            )}
            {/* <Tab eventKey="esgAI" title={t('ESGAI.label')}>
              {activeTab === 'esgAI' && (
                <div className="EsgAI_card">
                  <AIConfiguration />
                </div>
              )}
            </Tab> */}
            {!restrictNavToGoalsKpi && (
              <Tab eventKey="implGuide" title={t("ImplementationGuide.label")}>
                {activeTab === 'implGuide' && (
                  <div className=" border-0">
                    <ImplementationGuide
                      onNavigateTab={(tabKey) => handleSelect(tabKey)} />
                  </div>
                )}
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
      {showDeleteConfirm && (
        <ConfirmationModal
          modalShow={true}
          messageText={messageConfirmation}
          callbackModal={callbackDeleteImg}
          confirmBtn={t("Confirm.label")}
          CancelBtn={t("Cancel.label")}
        />
      )}
    </div>
  );
}
CompanySettings.propTypes = {};
CompanySettings.defaultProps = {};
export default withTranslation()(CompanySettings);
